define('type/compilation/CompilationStatus',[
  'jquery',
  'common/js/lib/Serum.Time',
  'common/js/lib/Serum.Pubsub',
  'common/module/realtime/Serum.RealtimeUpdater',
  'common/module/realtime/Serum.RealtimeWidget',
  'common/module/media/Serum.MediaMetadata'
], function($, Time, Pubsub, RealtimeUpdater, RealtimeWidget, MediaMetadata) {
  'use strict';

  var REDMODE_TIME_CUTOFF = 3600000;
  var REDMODE_BULLETIN_CUTOFF = 3;

  function getContent(id) {
    return $.ajax('/serum/api/content/json/' + id, {
      data : {
        v : 2,
        limit : REDMODE_BULLETIN_CUTOFF,
        context : 'items'
      }
    }).fail(function(error){
      console.error(error); //eslint-disable-line no-console
    });
  }

  function getHtml(id, perspective) {
    return $.get('/serum/api/render/' + id + '?perspective=' + perspective)
      .fail(function(error){
        console.error(error); //eslint-disable-line no-console
      });
  }

  var CompilationStatus = function($element, shouldSetupRealtimeUpdating) {
    var id = $element.attr('data-id') || false,
      video = null,
      videoId = $element.attr('data-video-id') || false,
      widget = null,
      $parent = $element.parent('.compilation-reference'),
      $flow = $element.parents('.flow'),
      flowWidget = $flow.data('widget'),
      isDisabledBecauseAutoplay = false,
      isCompilationRich = $element.hasClass('rich');

    function setupRealtimeUpdating() {
      RealtimeUpdater.get().addTarget($element);
      widget = new RealtimeWidget($element);
    }

    function disableRealtimeUpdating() {
      isDisabledBecauseAutoplay = true;

      // disable auto-update of this compilation
      if(widget) {
        widget.destroy();
      }

      // disable auto-update of parent flow
      if(flowWidget) {
        flowWidget.pause();
      }
    }

    function setupRedmodeDetection() {
      $.when(checkIfRecentOrRedmodeBulletins(id))
      .then(function(hasRecentOrRedmodeBulletins) {
        var hasLiveVideo = video && video.liveStatus && video.liveStatus.isLive;

        return Boolean(hasRecentOrRedmodeBulletins || hasLiveVideo);
      })
      .then(function (isInRedMode) {
        $element.toggleClass('emphasis-high', isInRedMode);
        $element.find('.compilation-status').attr('aria-hidden', !isInRedMode);
      })
      .always(function () {
        if (video && video.liveStatus) {
          styleLiveVideoStatus(video.liveStatus);
        }
        checkIfShouldGoLarge();
      });
    }

    function setupFlowChangeDetection() {
      $flow.on('realtimereorder', function(){
        checkIfShouldGoLarge();
      });
    }

    function setupVideoReadyDetection() {
      Pubsub.subscribe(Pubsub.topics.VIDEO_DID_PREPARE, checkIfVideoBelongsToCompilation);
    }

    function checkIfShouldGoLarge() {
      if($flow.hasClass('newsroom-top-flow') && $parent.is(':first-child')) {
        var shouldGoLarge = Boolean($element.hasClass('emphasis-high') || videoId);

        $parent.toggleClass('go-large', shouldGoLarge);
        checkIfPlugVideoShouldPlay();
      }
    }

    function liveVideoIsOngoing (videoView) {
      if (!Array.isArray(window.ludoPlayers)) {
        return false; // should NEVER happen
      }

      return window.ludoPlayers.filter(function (entry) {
        return videoView === entry.view;
      }).reduce(function (current, entry) {
        return current === true ? true : entry.liveStatus && entry.liveStatus.isLive === true;
      }, false);
    }

    function videoCanPlay (videoMustBeLive) {
      if (!video || !video.player || !video.player.current()) {
        return false;
      }

      var mediaItem = video.player.current();
      var passedLiveCheck = videoMustBeLive ?
        mediaItem.isLive && liveVideoIsOngoing(video.view)
        : true;

      return mediaItem.isPlayable && passedLiveCheck;
    }

    function playVideo() {
      if (video && video.player) {
        video.player.set('mute', true); // player.mute() will not work, this does!
        // PUB-12453 temp workaround for a suspected race condition in Ludo player
        setTimeout(function () {
          video.player.play();
        }, 100);
      } else {
        console.log('playVideo() called, but video doesnt exist or have a player property'); //eslint-disable-line no-console
      }
    }

    function checkIfStandaloneVideoShouldPlay() {
      if( videoCanPlay(true) ) {
        playVideo();
      }
    }

    function checkIfPlugVideoShouldPlay() {
      var hasLargeParent = $parent.hasClass('go-large');
      var hasVideoCanPlay = videoCanPlay(false);

      if(!isDisabledBecauseAutoplay && hasLargeParent && hasVideoCanPlay) {
        disableRealtimeUpdating();
        playVideo();
      }
    }

    function checkIfVideoBelongsToCompilation () {
      if (Array.isArray(window.ludoPlayers)) {
        window.ludoPlayers.filter(function (ludoPlayer) {
          var belongsToCompilation = $element.find('.compilation-media').has(ludoPlayer.view).length;
          return belongsToCompilation;
        }).forEach(function (ludoPlayer) {
          Pubsub.unsubscribe(Pubsub.topics.VIDEO_DID_PREPARE, checkIfVideoBelongsToCompilation);
          video = ludoPlayer;
          if(isCompilationRich) {
            checkIfStandaloneVideoShouldPlay();
          } else {
            checkIfPlugVideoShouldPlay();
          }
        });
      } else {
        console.log('No global ludoPlayer index, aborting.'); //eslint-disable-line no-console
      }
    }

    function styleLiveVideoStatus (liveStatus, isAudio) {
      if (liveStatus.isLive || liveStatus.startTime) {
        $element.addClass('compilation-video-live');

        if (isAudio) {
          $element.addClass('compilation-audio-live');
        }

        if (liveStatus.startTime && new Date(liveStatus.startTime) > new Date()) {
          $element.addClass('compilation-media-pending');
        }
      }
    }

    function showRecentTeasers(ids) {
      var wrapper = $element[0].parentNode.querySelector('.compilation-aside-teasers');
      if (!wrapper) {
        return;
      }
      var compilationLink = $element[0].querySelector('a[data-id="' + id + '"]').href;
      ids.forEach(function (id) {
        var placeholder = document.createElement('span');
        wrapper.insertAdjacentElement('beforeend', placeholder);
        getHtml(id, 'REFERENCE').then(function (html) {
          placeholder.outerHTML = html;
          // link to teaser in compilation, not standalone
          wrapper.querySelector('a[data-id="' + id + '"]').href = compilationLink + '#' + id + '.' + id;
        });
      });
    }

    function checkIfRecentOrRedmodeBulletins(compilationID) {
      var deferred = $.Deferred();

      if (!compilationID) {
        deferred.resolve(false);
        return deferred;
      }

      getContent(compilationID).then(function(data) {
        if (data.relations.length === 0) {
          deferred.resolve(false);
        } else {
          var timestamp = Time.now().getTime() - REDMODE_TIME_CUTOFF;
          var recentTeasers = data.relations.filter(function (teaser) {
            return new Date(teaser.created).getTime() > timestamp;
          });

          showRecentTeasers(recentTeasers.map(function(teaser){
            return teaser.id;
          }));

          // If all teasers are within the cutoff, resolve true (a lot is happening, activate redmode)
          if (recentTeasers.length === data.relations.length) {
            deferred.resolve(true);
          } else {
            var deferredTeasers = recentTeasers.map(function (teaser) {
              return getContent(teaser.id);
            })
            // Check if any of the recent teasers have emphasis = HIGH
            $.when.apply(null, deferredTeasers).then(function () {
              // Make sure our arguments are an array
              var bulletinResponses = deferredTeasers.length === 1 ? [arguments] : Array.prototype.slice.call(arguments),
                hasRedmodeBulletin = bulletinResponses.some(function (bulletinAjax) {
                  var bulletinResponse = bulletinAjax[0];
                  return bulletinResponse && bulletinResponse.emphasis && bulletinResponse.emphasis === 'HIGH';
                });
              deferred.resolve(hasRedmodeBulletin);
            });
          }
        }
      });

      return deferred;
    }

    function setupLiveMediaStyling () {
      var videoType = null,
        isAudio = false;

      if (Boolean(videoId)) {
        videoType = $element.find('figure.video').attr('data-video-type');
        isAudio = $element.find('figure.video').attr('data-audio-as-video') === 'true';

        if (['DEFAULT', 'LATEST'].indexOf(videoType) > -1) {
          $.when(MediaMetadata.getLiveStatus(videoId, videoType === 'LATEST'))
          .then(function (liveStatus) {
            styleLiveVideoStatus(liveStatus, isAudio);
          })
        }
      }
    }

    (function initalize() {
      if(shouldSetupRealtimeUpdating) {
        setupRealtimeUpdating();
      }
      setupVideoReadyDetection();
      setupRedmodeDetection();
      setupFlowChangeDetection();
      setupLiveMediaStyling();
    })();

    return {
      update: function() {
        setupRedmodeDetection();
      }
    };
  };

  CompilationStatus.bootstrap = function(selector) {
    var i, elements;
    selector = selector || '.compilation.js-initialize';
    elements = document.querySelectorAll(selector);

    for (i = 0; i < elements.length; i++) {
      new CompilationStatus($(elements[i]).removeClass('js-initialize'), true); //eslint-disable-line no-new
    }
  };

  return CompilationStatus;

});

